import React, { useEffect } from 'react'
import BecomeAMemberContainer from '../containers/BecomeAMember'
import Nav from '../components/nav/Nav';

const BecomeAMember: React.FC= () => {


  useEffect(() => {
    document.title = 'Elite Community CU | Become A Member';

    const metaDescription = document.createElement('meta');
    metaDescription.name = 'description';
    metaDescription.content = "Elite Community Credit Union is committed to meet our members' financial needs and assist them in attaining their financial goals";
    document.head.appendChild(metaDescription);
  }, []);

  return (
    <div>
      <Nav />
      <BecomeAMemberContainer />
    </div>
  )
}

export default BecomeAMember